<template>
  <div class="auth-main auth-main__forgot-password">
    <main
      id="main"
      class="main--login"
      data-page-id="login"
    >
      <section class="section-login">
        <Header :is-whitelabel="isWhitelabel" />
        <div class="login-form-wrapper">
          <div class="loginv2-container p-b-20">
            <div class="row">
              <div
                class="login_logo"
                :class="{ 'login_logo--ringba': !isWhitelabel }"
              />
            </div>
            <ForgotPasswordForm
              :action-status="actionStatus"
              @forgot-password="onForgotPassword"
            />
          </div>
        </div>
      </section>
      <Footer v-if="!isWhitelabel" />
      <WhitelabelFooter v-if="isWhitelabel" />
    </main>
  </div>
</template>

<script>
import Footer from '@/modules/auth/components/Footer';
import Header from '@/modules/auth/components/Header';
import ForgotPasswordForm from '@/modules/auth/components/ForgotPassword/ForgotPasswordForm';
import WhitelabelFooter from '@/modules/auth/components/WhitelabelFooter';
import { mapState, mapActions } from 'vuex';
import { getStatus } from '@/store/helpers';

export default {
  components: { Footer, Header, ForgotPasswordForm, WhitelabelFooter },
  props: {
    isWhitelabel: {
      type: Boolean,
      default() {
        return true;
      },
    },
    accountId: {
      type: String,
      default() {
        return null;
      },
    },
  },
  computed: {
    ...mapState('auth', {
      actionStatus: (state) => getStatus(state, 'sendForgotPasswordRequest')
    })
  },
  methods: {
    ...mapActions('auth', ['sendForgotPasswordRequest']),
    onForgotPassword(data) {
      const {email} = data;
      const {accountId} = this;
      this.sendForgotPasswordRequest({email, accountId});
    },
  },
};
</script>

<style lang="scss" scoped>
.auth-main__forgot-password {
  --component-login__welcome-sub-message: 'Forgot your Password?';
}
</style>